import {Component} from "../common/component";


import * as d3Selection from 'd3-selection'
import * as d3Dispatch from 'd3-dispatch'
import * as d3Array from 'd3-array'
import * as d3Fetch from 'd3-fetch'
import * as d3Dsv from 'd3-dsv'
const d3=Object.assign({},d3Selection,d3Dispatch,d3Array,d3Fetch,d3Dsv);

class ScrollingContent extends Component {

    static _type='_scTxt';

    constructor(id){
        super(id);
        this._outerContainer = d3.create('div').attr('id',id).attr('class','scrollable');
        this._innerContainer = this._outerContainer.append('div').attr('class','inner');
    }

    /**
     * Injecte des données dans l'instance
     * @param {String} name nom
     * @param {*} dataset   données
     * @param {Function} [dataTransform]    fonction optionnelle de transformation à applique au dataset
     * @returns {ScrollingContent}
     */
    data(name,dataset, dataTransform=(d)=>d){
        this._data = this._data || new Map();
        this._data.set(name,dataTransform(dataset));
        return this;
    }

    update(dataset){

    }

    render(){

    }
}

export {ScrollingContent}